import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import PageHeader from '../../components/PageHeader.react.js';
import { findObrasMapa } from '../Actions.js';
import MapaObrasPublicasFilters, {
  INITIAL_FILTROS
} from './MapaObrasPublicasFilters.react.js';
import { MapaObrasPublicasMapView } from './MapaObrasPublicasMapView.react.js';
import MapaObrasPublicasList from './MapaObrasPublicasList.react.js';
import { useEffect } from 'react';

const MapaObrasPublicasForm = ({ location, obras, loading, findObrasMapa }) => {
  const [obraExpandida, setObraExpandida] = useState(undefined);
  const [filtros, setFiltros] = useState(INITIAL_FILTROS);
  const mapViewRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    findObrasMapa(filtros);
  }, []);

  const handleConsulta = useCallback(() => {
    setObraExpandida(undefined);
    findObrasMapa(filtros);
  }, [filtros, findObrasMapa]);

  const handleReset = useCallback(() => {
    setFiltros(INITIAL_FILTROS);
    setObraExpandida(undefined);
    findObrasMapa(INITIAL_FILTROS);
  }, [findObrasMapa]);

  const handleObraClick = obraId => {
    setObraExpandida(prev => (prev === obraId ? undefined : obraId));
  };

  const handleImovelClick = (obra, imIdx) => {
    const imovel = obra.imoveis[imIdx];
    if (!imovel.latitude || !imovel.longitude) return;
    mapViewRef.current && mapViewRef.current.flyToImovel(obra, imIdx);
  };

  const handleVerObra = obraId => {
    history.push(`/obraspublicas/detalhes?idOxy=${obraId}`);
  };

  return (
    <section>
      <PageHeader location={location} />

      <MapaObrasPublicasFilters
        filtros={filtros}
        onChange={setFiltros}
        onConsulta={handleConsulta}
        onReset={handleReset}
      />

      <div
        style={{
          display: 'flex',
          gap: '8px',
          height: 'calc(100vh - 320px)',
          minHeight: '400px',
          marginTop: '16px'
        }}
      >
        <div style={{ flex: 1 }}>
          <MapaObrasPublicasMapView
            ref={mapViewRef}
            obras={obras}
            loading={loading}
            height="100%"
            onMarkerClick={obra => setObraExpandida(obra.idOxy)}
            onVerObra={handleVerObra}
          />
        </div>
        <div
          style={{
            width: '340px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '4px'
          }}
        >
          <MapaObrasPublicasList
            obras={obras}
            loading={loading}
            obraExpandida={obraExpandida}
            onObraClick={handleObraClick}
            onImovelClick={handleImovelClick}
            onVerObra={handleVerObra}
          />
        </div>
      </div>
    </section>
  );
};

function mapStateToProps(state) {
  return {
    obras: state.obra.get('obrasMapa').toJS(),
    loading: state.obra.get('loading')
  };
}

export default connect(mapStateToProps, { findObrasMapa })(
  MapaObrasPublicasForm
);
